/* <footer-accordion> - footer columns (FOOT-01).
   Mobile (< 990px): native <details> accordions, closed by default.
   Desktop (>= 990px): every column is open and the summary does not toggle.
   Without JS the columns still work as native <details>. */
if (!customElements.get('footer-accordion')) {
  class FooterAccordion extends HTMLElement {
    connectedCallback() {
      this.query = window.matchMedia('(min-width: 990px)');
      this.onChange = () => this.sync();
      this.onClick = (event) => {
        if (!this.query.matches) return;
        const summary = event.target.closest('summary');
        if (summary && this.contains(summary)) event.preventDefault();
      };
      this.query.addEventListener('change', this.onChange);
      this.addEventListener('click', this.onClick);
      this.sync();
    }

    disconnectedCallback() {
      if (this.query) this.query.removeEventListener('change', this.onChange);
      this.removeEventListener('click', this.onClick);
    }

    sync() {
      const desktop = this.query.matches;
      this.querySelectorAll(':scope > details').forEach((details) => {
        if (desktop) {
          details.setAttribute('open', '');
        } else {
          details.removeAttribute('open');
        }
      });
    }
  }

  customElements.define('footer-accordion', FooterAccordion);
}
